var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "form-url-modal",
      "footer-class": _vm.isEvent ? 'd-flex justify-content-end' : 'd-flex justify-content-center'
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', {
          staticClass: "m-0 align-self-center"
        }, [_vm._v(_vm._s(_vm.formTitle))]), _c('b-button', {
          staticClass: "text-dark",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "height": "20px"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 320 512"
          }
        }, [_c('path', {
          attrs: {
            "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "modal-button-group d-flex w-100 align-items-center",
          staticStyle: {
            "position": "relative",
            "min-height": "42px"
          }
        }, [!_vm.isEvent ? _c('div', {
          staticClass: "flex-grow-1 d-flex justify-content-center"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.downloadQRCode(_vm.$refs.formQRcode, "".concat(_vm.formTitle, "_\u586B\u5BEB\u7DB2\u5740"));
            }
          }
        }, [_vm._v(" 下載QRCode ")])], 1) : _vm._e(), _c('b-button', {
          staticStyle: {
            "position": "absolute",
            "right": "0"
          },
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('form-url-modal');
            }
          }
        }, [_vm._v(" 關閉 ")])], 1)];
      },
      proxy: true
    }])
  }, [_vm.isEvent ? [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("填寫網址")]), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    attrs: {
      "id": "form-url"
    },
    on: {
      "click": function click($event) {
        return _vm.copyFormUrl('#form-url');
      }
    },
    model: {
      value: _vm.formUrl,
      callback: function callback($$v) {
        _vm.formUrl = $$v;
      },
      expression: "formUrl"
    }
  }), _vm.formUrl ? _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('vue-qr', {
    ref: "formQRcode",
    attrs: {
      "text": _vm.formUrl
    }
  }), _c('b-button', {
    staticClass: "center-button",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadQRCode(_vm.$refs.formQRcode, "".concat(_vm.formTitle, "_\u586B\u5BEB\u7DB2\u5740"));
      }
    }
  }, [_vm._v(" 下載QRCode ")])], 1) : _vm._e(), _vm.checkinUrl ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), !!_vm.checkinUrl ? [_c('h5', {
    staticClass: "my-2"
  }, [_vm._v("報到網址")]), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    attrs: {
      "id": "checkin-url"
    },
    on: {
      "click": function click($event) {
        return _vm.copyFormUrl('#checkin-url');
      }
    },
    model: {
      value: _vm.checkinUrl,
      callback: function callback($$v) {
        _vm.checkinUrl = $$v;
      },
      expression: "checkinUrl"
    }
  }), _vm.checkinUrl ? _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('vue-qr', {
    ref: "checkinQRcode",
    attrs: {
      "text": _vm.checkinUrl
    }
  }), _c('b-button', {
    staticClass: "center-button",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadQRCode(_vm.$refs.checkinQRcode, "".concat(_vm.formTitle, "_\u5831\u5230\u7DB2\u5740"));
      }
    }
  }, [_vm._v(" 下載QRCode ")])], 1) : _vm._e()] : _vm._e()] : [_c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("填寫網址")]), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    attrs: {
      "id": "form-url"
    },
    on: {
      "click": function click($event) {
        return _vm.copyFormUrl('#form-url');
      }
    },
    model: {
      value: _vm.formUrl,
      callback: function callback($$v) {
        _vm.formUrl = $$v;
      },
      expression: "formUrl"
    }
  }), _c('div', [_c('vue-qr', {
    ref: "formQRcode",
    attrs: {
      "text": _vm.formUrl
    }
  })], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }